import { ROLE_NAME } from './roles.constants.js';
/**
 * The global Admin role, which the seed rewrites on every run: an edit would not stick, so the API
 * refuses to change or delete it and the web apps don't offer to.
 */
export function isProtectedRole(role) {
    return role.municipalityId === null && role.name === ROLE_NAME.ADMIN;
}
